import React from 'react';
import { motion } from 'framer-motion';
import './hero.css';
import './Hero3D.css';
import { Typewriter } from 'react-simple-typewriter';
import javascript from '../../assets/images/javascript.svg';
import react from '../../assets/images/react.png';
import rails from '../../assets/images/ruby-on-rails.svg';
import nodejs from '../../assets/images/nodejs.svg';
import tailwind from '../../assets/images/tailwind.svg';
import redux from '../../assets/images/redux.svg';
import express from '../../assets/images/express.svg';
import mongodb from '../../assets/images/mongodb.svg';
import nextjs from '../../assets/images/next.avif';
import Hero3D from './Hero3D';

const Hero = () => (
  <>
    <section className="hero" id="home">
      <div className="container top">
        <div className="left hero-left top" data-aos="slide-left">
          <h3 className="welcome">WELCOME TO MY WORLD</h3>
          <h1>
            Hi, I'm
            <span> Sentayhu Berhanu</span>
          </h1>
          <h2>
            <span>
              <Typewriter
                words={['Professional Coder', 'Full-Stack Developer']}
                loop
                cursor
                cursorStyle="_"
                typeSpeed={70}
                deleteSpeed={50}
                delaySpeed={1000}
              />
            </span>
          </h2>
          <p>
            I am a software developer with around 4 years of experience, specializing in building web and mobile applications using React, Redux, React Native, Next.js, Vue.js, and Express.js. I have worked on projects including e-commerce applications and video streaming platforms where doctors and patients can connect via video, phone, and chat. I am passionate about creating scalable web applications and am always eager to take on new challenges.
          </p>
          <div className="hero_btn d_flex d_flex_mob">
            <div className="col_1">
              <h4>LETS CONNECT</h4>
              <div className="button">
                <a title="Twitter" href="https://twitter.com/VoltageBerhanu" target="_blank" rel="noreferrer">
                  <button type="button" className="btn_shadow">
                    <i className="fab fa-twitter" />
                  </button>
                </a>
                <a title="AngelList" href="https://angel.co/u/sentayhu-berhanu" target="_blank" rel="noreferrer">
                  <button type="button" className="btn_shadow">
                    <i className="fab fa-angellist" />
                  </button>
                </a>
                <a title="LinkedIn" href="https://www.linkedin.com/in/sentayhu-berhanu" target="_blank" rel="noreferrer">
                  <button type="button" className="btn_shadow">
                    <i className="fab fa-linkedin-in" />
                  </button>
                </a>
              </div>
            </div>
            <div className="col_1">
              <h4>BEST SKILL ON </h4>
              <div className="best-skill">
                <button title="JavaScript" type="button" className="btn_shadow">
                  <img src={javascript} alt="skil" />
                </button>
                <button title="React" type="button" className="btn_shadow">
                  <img src={react} alt="skil" />
                </button>
                <button title="Ruby on Rails" type="button" className="btn_shadow">
                  <img src={rails} alt="skil" />
                </button>
                <button title="NodeJS" type="button" className="btn_shadow">
                  <img src={nodejs} alt="skil" />
                </button>
                <button title="Tailwind CSS" type="button" className="btn_shadow">
                  <img src={tailwind} alt="skil" />
                </button>
                <button title="Redux" type="button" className="btn_shadow">
                  <img src={redux} alt="skil" />
                </button>
                <button title="Express" type="button" className="btn_shadow">
                  <img src={express} alt="skil" />
                </button>
                <button title="MongoDB" type="button" className="btn_shadow">
                  <img src={mongodb} alt="skil" />
                </button>
                <button title="Next.js" type="button" className="btn_shadow">
                  <img src={nextjs} alt="skil" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* 3D Interactive Component - Desktop Only */}
        <Hero3D />
      </div>
    </section>
  </>
);

export default Hero;
